'use client';

import { cn } from '@workspace/lib';
import { useProductCarousel } from './useProductCarousel';
import {
  ProductCarouselHeader,
  ProductCarouselMobileViewport,
  ProductCarouselDesktopViewport,
  ProductCarouselDots,
} from './ui';
import { ProductCarouselProps } from './product-carousel.types';

export function ProductCarousel({ block }: ProductCarouselProps) {
  const {
    slides,
    mobileSlideGroups,
    resolvedHeadingText,
    backgroundClass,
    layoutOptions,
    viewportRefMobile,
    selectedIndexMobile,
    snapCountMobile,
    goPrevMobile,
    goNextMobile,
    goToSlideMobile,
    viewportRefDesktop,
    selectedIndexDesktop,
    snapCountDesktop,
    goPrevDesktop,
    goNextDesktop,
    goToSlideDesktop,
  } = useProductCarousel({ block });

  return (
    <div className={cn('product-carousel-bg relative w-full overflow-hidden', backgroundClass)}>
      <div className="product-carousel-container md:py-3xl py-xl wrapper mx-auto px-6">
        <div className="product-carousel-wrapper w-full flex flex-col md:flex-row gap-8 md:gap-32 items-center justify-center">
          <div className="flex flex-col w-full flex-1">
            {/* Header */}
            <ProductCarouselHeader
              heading={resolvedHeadingText}
              showMobileNav={mobileSlideGroups.length > 2}
              showDesktopNav={slides.length > 2}
              onNextMobile={goNextMobile}
              onPrevMobile={goPrevMobile}
              onNextDesktop={goNextDesktop}
              onPrevDesktop={goPrevDesktop}
            />

            {/* Mobile viewport (groups of 3) */}
            <ProductCarouselMobileViewport viewportRef={viewportRefMobile} mobileSlideGroups={mobileSlideGroups} />

            {/* Desktop viewport (original behavior) */}
            <ProductCarouselDesktopViewport
              viewportRef={viewportRefDesktop}
              slides={slides}
              layoutOptions={layoutOptions}
            />

            {/* Dots bound to Embla snaps */}
            {/* Mobile dots */}
            <div className="md:hidden">
              <ProductCarouselDots
                snapCount={snapCountMobile}
                selectedIndex={selectedIndexMobile}
                onDotClick={goToSlideMobile}
                className="justify-center mt-lg"
              />
            </div>
            {/* Desktop dots */}
            <div className="hidden md:flex">
              <ProductCarouselDots
                snapCount={snapCountDesktop}
                selectedIndex={selectedIndexDesktop}
                onDotClick={goToSlideDesktop}
                className="justify-start mt-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
